import { jsx as _jsx } from "react/jsx-runtime";
import { FieldType } from '@/catalog/constants/fieldTypes';
import { ALL_CONTEXTS } from '@/common/constants/context';
import MetricScaleContainer from '@/metric/components/MetricScaleContainer/MetricScaleContainer';
import OptMetricBar from '@/metric/components/OptMetricBar/OptMetricBar';
import Diamond from '@/product/entity/Diamond';
export const FIELD_DEAD_ZONE = {
    key: 'dz',
    label: 'Dead zones',
    fullLabel: 'Dead zones',
    type: FieldType.Metric,
    icon: 'deadzone',
    getter(p) {
        if (p instanceof Diamond && p.deadZoneMetric) {
            return p.deadZoneMetric.val;
        }
        return null;
    },
    getterPlain(p) {
        if (p instanceof Diamond && p.deadZoneMetric) {
            return Number(p.deadZoneMetric.val);
        }
        return null;
    },
    decorator: (_, p, { ratio, size, label, icon, metricClassName } = {}) => {
        if (p instanceof Diamond) {
            return (_jsx(OptMetricBar, { metric: p.deadZoneMetric, ratio: ratio, type: "deadzones", children: (scale, abs) => (_jsx(MetricScaleContainer, { size: size, icon: icon, className: metricClassName, label: label, scale: scale, abs: abs, isMetricCalculated: Boolean(p.deadZoneMetric) })) }));
        }
        return null;
    },
    iteratee(p) {
        if (p instanceof Diamond && p.deadZoneMetric) {
            return p.deadZoneMetric.val;
        }
        return null;
    },
    contexts: ALL_CONTEXTS,
};
